<template>
  <div class="relative">
    <ArticleCardEmbed
      v-if="entry.embedArticle"
      :article="entry.embedArticle"
      :data-layer="{ name: `Haber Detay - Önerilen İçerikler`, position: 1 }"
    />
  </div>
</template>

<script>
import { defineComponent } from '@nuxtjs/composition-api';
import ArticleCardEmbed from './ArticleCardEmbed.vue';

export default defineComponent({
  components: { ArticleCardEmbed },
  props: {
    entry: {
      type: Object,
      required: true,
    },
  },
});
</script>
